import { render, staticRenderFns } from "./StudentsDisplay.vue?vue&type=template&id=392c56d4"
import script from "./StudentsDisplay.vue?vue&type=script&lang=js"
export * from "./StudentsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports